<div style="width: 100%">
  <canvas id="opportunity-chart" width="500"></canvas>
</div>
